import {BrokenRule} from './broken-rule';
import {AuditableResult} from './auditable-result';
import {RestrictedIata} from './restricted-iata';

export class AuditableRestrictedIatas extends AuditableResult<Array<RestrictedIata>> {
  constructor(restrictedIatas: Array<RestrictedIata>, brokenRules: Array<BrokenRule> = new Array<BrokenRule>()) {
    super(restrictedIatas, brokenRules);
  }

  static parseRestrictedIatasResponse(jsonArray: any) {
    let success = jsonArray['wasSuccessful'];
    let iatas = [];


    if (success) {
      iatas = jsonArray["restrictedIatas"].map(response => Object.assign(new RestrictedIata(), {
        id: response.id,
        iataNumber: response.iataNumber,
        isIncluded: response.isIncluded,
        iataPartner: response.iataPartner,
        createdBy: response.createdBy,
        createdDate: response.createdDate,
        updatedBy: response.updatedBy,
        updatedDate: response.updatedDate
      }));
    }else {
      let brokenRules = jsonArray["brokenRules"].map(response => Object.assign(new BrokenRule, {
        message: response.message,
      }));
      return new AuditableRestrictedIatas([], brokenRules);
    }
    return new AuditableRestrictedIatas(iatas, []);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/models/auditable-restricted-iatas.ts